import React, { useRef, useEffect } from "react";
import useFadeIn from "../hooks/useFadeIn";
import "../styles/GlobalStyles.css";

const SERVICES = [
  {
    name: "Lash Lift & Tint",
    desc: "Not an extension girlie? No worries! Lash lifts add a natural curl that opens up your eyes using a safe perming solution. With the tint, your lashes will look dark like mascara — no curlers needed. Results last 6–8 weeks."
  },
  {
    name: "Lash Extensions",
    desc: "Lash extensions are extremely convenient and will quite literally change your life. I price my fills and full sets the same for every lash style. You'll leave feeling full, clean, and confident after every appointment — and you can change your style at any time at no extra cost."
  },
  {
    name: "Eyebrow Lamination",
    desc: "This service sets your natural brow hairs into your desired shape using a safe perming solution. Brows will look fuller, neater, and perfected — effortlessly styled brows every day for weeks."
  },
  {
    name: "Eyebrow Wax",
    desc: "I'll perfectly wax your brows to your desired shape using hard wax."
  },
  {
    name: "GLOCO Brow Works",
    desc: "Want PERFECT brows? Book this service for a wax, tint, and lamination all in one."
  }
];

function useSlideIn(direction) {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          el.classList.add("visible");
          obs.unobserve(el);
        }
      },
      { threshold: 0.12, rootMargin: "0px 0px -40px 0px" }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);
  return ref;
}

const ServiceCard = ({ name, desc, index }) => {
  const dir = index % 2 === 0 ? "slide-left" : "slide-right";
  const ref = useSlideIn(dir);
  return (
    <article
      ref={ref}
      className={`card ${dir}`}
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "12px",
        transitionDelay: `${index * 0.07}s`
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "space-between",
          gap: "8px"
        }}
      >
        <h3 style={{ color: "var(--dark)" }}>{name}</h3>
        <span
          style={{ fontSize: "1.1rem", color: "var(--blush)", flexShrink: 0 }}
        >
          ✦
        </span>
      </div>
      <hr className="divider" style={{ margin: "0" }} />
      <p style={{ color: "var(--mid)", fontSize: "0.95rem" }}>{desc}</p>
      <div>
        <a
          href="https://afterglobeautyco.square.site/"
          target="_blank"
          rel="noopener noreferrer"
          className="btn btn-outline"
          style={{ fontSize: "0.78rem", padding: "10px 22px" }}
        >
          Book This Service
        </a>
      </div>
    </article>
  );
};

const ServicesPage = () => {
  const refHeader = useFadeIn();
  const refCta = useFadeIn();
  return (
    <main className="page-wrap">
      <div ref={refHeader} className="fade-up">
        <h2 style={{ marginBottom: "28px" }}>My Services</h2>
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
        {SERVICES.map((s, i) => (
          <ServiceCard key={s.name} name={s.name} desc={s.desc} index={i} />
        ))}
      </div>
      <div
        ref={refCta}
        className="fade-up"
        style={{ textAlign: "center", marginTop: "8px" }}
      >
        <a
          href="https://afterglobeautyco.square.site/"
          target="_blank"
          rel="noopener noreferrer"
          className="btn btn-primary"
        >
          Book Now
        </a>
      </div>
    </main>
  );
};

export default ServicesPage;
